import { createContext } from "solid-js";
const BottomNavigationContext = createContext({
    onChange: () => () => undefined,
    showLabels: () => false,
    selectedValue: () => undefined,
    getIndex: () => 0,
});
export default BottomNavigationContext;
